<template>
  <div class="positions">
    <Header search="true" v-if="show_header">
      <li class="float-left">
        <router-link to="/positions/new">
          <i class="tm-icon zmdi zmdi-plus-circle"></i>
          <span class="nav-title">Добавить позицию</span>
        </router-link>
      </li>
      <!--<li v-bind:class="{active: filtersEnabled}" class="float-right">
        <a v-on:click="toggleFilters">
          <i class="tm-icon zmdi zmdi-filter-list"></i>
          <span class="nav-title">Открыть фильтры</span>
        </a>
      </li>-->

      <!--<li class="float-right">
        <b-dropdown variant="custom">
          <template slot="button-content">
            <i
              class="tm-icon zmdi"
              v-bind:class="{
                'zmdi-view-list': isActiveView('Table'),
                'zmdi-view-agenda': isActiveView('Cards'),
                'zmdi-chart': isActiveView('Chart'),
              }"
            ></i>
            <span class="nav-title">Изменить интерфейс</span>
          </template>
          <b-dropdown-item v-on:click="toggleView('Table')">
            <i class="tm-icon zmdi zmdi-view-list"></i> Таблица
          </b-dropdown-item>
          <b-dropdown-item v-on:click="toggleView('Cards')">
            <i class="tm-icon zmdi zmdi-view-agenda"></i> Карточки
          </b-dropdown-item>
        </b-dropdown>
      </li>-->
      <!--<li class="float-right" v-if="config && config.report_configurations">
        <a v-if="report && report.state == 'requested'">
          <i class="tm-icon zmdi zmdi-spinner zmdi-hc-spin"></i>
          <span class="nav-title">Отчет формируется</span>
        </a>
        <b-dropdown variant="custom" v-else>
          <template slot="button-content">
            <i class="tm-icon zmdi zmdi-cloud-download"></i>
            <span class="nav-title">Скачать отчет</span>
          </template>
          <b-dropdown-item
            v-for="reportConfig in config.report_configurations"
            :key="reportConfig.id"
            @click="makeReport(reportConfig)"
          >
              {{reportConfig.name}}
          </b-dropdown-item>
        </b-dropdown>
      </li>-->
      <!--
      <li class="float-right">
        <b-dropdown variant="custom">
          <template slot="button-content">
            <i class="tm-icon zmdi zmdi-shopping-cart"></i>
            <span class="nav-title">Архив заказов</span>
          </template>
          <b-dropdown-item>
            <i class="zmdi zmdi-play-circle-outline"></i>
            Активные
          </b-dropdown-item>
          <b-dropdown-item>
            <i class="zmdi zmdi-close-circle-o"></i>
            Закрытые
          </b-dropdown-item>
          <b-dropdown-item>
            <i class="zmdi zmdi-minus-circle-outline"></i>
            Отмененные
          </b-dropdown-item>
        </b-dropdown>
      </li>
    -->
    </Header>
    <NavbarRight>
      <form @submit.prevent="search">
      <div class="card mb-5 pb-5">
        <div class="card-body">

            <br>
            <br>

            <AutocompleteInput
              :multiple="true"
              label="Фильтры"
              attribute="in_any_filters"
              :item="f"
              :resource="'filter'"
              :resource_params="{type_in: ['Filter::PositionFilter']}"
            ></AutocompleteInput>
          </div>
        </div>

        <button
          type="submit"
          class="btn btn-success btn-block btn-lg btn-fixed-bottom"
        >
          <i class="zmdi zmdi-search"></i>
          Найти
        </button>
      </form>
    </NavbarRight>

    <Counts></Counts>

    <Table></Table>

    <infinite-loading
      @infinite="infiniteItems"
      :identifier="infiniteId"
    ></infinite-loading>
  </div>
</template>

<script>
import NavbarRight from '../shared/navbar-right.vue'
import Counts from '../shared/counts'

import FiltersMixin from '../../services/filters_mixin'
import CollectionMixin from '../../services/collection_mixin'
import ViewsMixin from '../../services/views_mixin'


import Table from './views/table'

export default {
  props: {
    show_header: {
      required: true
    }
  },
  mixins: [
    CollectionMixin,
    FiltersMixin,
    ViewsMixin
  ],
  components: {
    NavbarRight,
    Table,
    Counts
  },
  data: function(){
    return {
      currentView: 'Table',
      resourceName: 'position',
      filtersData: [
        {
          "g": [
            {
              "m":"and",
              "c":[
                {
                  "a":"kind_id",
                  "p":"in",
                  "v":[]
                }
              ]
            }
          ]
        }
      ]
    }
  }
}
</script>
